<template>
  <v-list three-lines class="pa-0">
    <template v-for="product in productTypes">
      <v-layout
        row
        style="border-bottom: 1px solid rgba(0,0,0,.12)"
        class="product-type-info"
        :key="`${product.codigo_produto}-${product.codigo_tipo}`"
        :style="
          hoverShape &&
          Number(product.codigo_produto) === Number(hoverShape) &&
          product.mapa_coordenadas &&
          product.mapa_coordenadas.length
            ? 'background-color: rgba(255,255,0,0.1)'
            : ''
        "
        @mouseenter="$store.commit('SET_HOVER_SHAPE', product.codigo_produto)"
        @mouseleave="$store.commit('SET_HOVER_SHAPE', null)"
      >
        <v-flex xs9 sm10 lg10>
          <h3 class="product-title" v-if="productsExpanded">
            {{ product.nome }} - {{ product.nome_tipo }}
          </h3>
          <h3 class="product-title" v-else>{{ product.nome_tipo }}</h3>
          <h4
            class="product-price"
            v-if="!product.encerrado && !product.esgotado"
            v-html="productPriceDetails(product)"
          ></h4>
        </v-flex>
        <v-flex xs3 sm2 lg2>
          <v-layout
            align-center
            justify-center
            row
            fill-height
            v-if="product.esgotado"
          >
            <v-chip outline color="#838D9B">Esgotado</v-chip>
          </v-layout>
          <v-layout
            align-center
            justify-center
            row
            fill-height
            v-else-if="product.encerrado"
          >
            <v-chip outline color="#838D9B">Encerrado</v-chip>
          </v-layout>
          <v-layout
            pr-2
            align-center
            justify-space-between
            row
            fill-height
            v-else
          >
            <div>
              <v-btn
                class="add-remove-button mr-2"
                outline
                small
                fab
                :style="
                  $route.name === 'totem'
                    ? 'height: 37px !important; width: 37px !important'
                    : ''
                "
                color="secondary"
                :disabled="product.quantidade === 0"
                @click="remove(product)"
              >
                <v-icon class="add-remove-button__icon">remove</v-icon>
              </v-btn>
            </div>
            <div class="text-xs-center mr-2">
              <span class="product-quantity secondary--text">{{
                product.quantidade
              }}</span>
            </div>
            <div>
              <v-btn
                class="add-remove-button mr-2"
                outline
                small
                fab
                :style="
                  $route.name === 'totem'
                    ? 'height: 37px !important; width: 37px !important'
                    : ''
                "
                color="secondary"
                :disabled="
                  product.quantidade >= product.quantidade_maxima ||
                    (productsQuantity >= maxProdutosCpf && maxProdutosCpf) ||
                    hasReachedMax ||
                    !!(product.cupom && productsQuantityCoupon >= maxCartCoupon)
                "
                @click="add(product)"
              >
                <v-icon class="add-remove-button__icon">add</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ['productTypes', 'productsLength'],
  computed: {
    ...mapGetters(['maxCartCoupon']),
    maxCartQuantity() {
      return this.$store.getters.maxProductsCart;
    },
    hoverShape() {
      return this.$store.getters.hoverShape;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    eventName() {
      return this.$store.getters.eventName;
    },
    productsExpanded() {
      return this.$store.getters.productsExpanded;
    },
    eventDetails() {
      return this.$store.getters.eventDetails;
    },
    maxProdutosCpf() {
      return this.$store.getters.maxProdutosCpf;
    },
    productsQuantity() {
      let total = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            total += v.quantidade;
          });
        });
      }
      return total;
    },
    productsQuantityCoupon() {
      let total = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            if (v.cupom) total += v.quantidade;
          });
        });
      }
      return total;
    },
    hasProductsCart() {
      let total = 0;
      this.cartProducts.forEach(p => {
        total += p.length;
      });
      return total;
    },
    hasReachedMax() {
      if (this.productsQuantity >= this.maxCartQuantity && this.maxCartQuantity)
        return true;
      else return false;
    },
  },
  methods: {
    add(product) {
      product.haveSeat = false;
      if (product.quantidade === 0 && product.quantidade_minima > 1) {
        for (var i = 0; i < product.quantidade_minima; i++) {
          this.$store.dispatch('addCartProduct', product);
          this.$store.dispatch('incrementProductsQuantity', product);
        }
      } else {
        this.$store.dispatch('addCartProduct', product);
        this.$store.dispatch('incrementProductsQuantity', product);
      }
    },
    remove(product) {
      if (product.quantidade <= 0) product.quantidade = 0;
      if (product.quantidade > 0) {
        product.haveSeat = false;
        if (product.quantidade === product.quantidade_minima) {
          for (var i = 0; i < product.quantidade_minima; i++) {
            this.$store.dispatch('removeCartProduct', product);
            this.$store.dispatch('decrementProductsQuantity', product);
          }
        } else {
          this.$store.dispatch('removeCartProduct', product);
          this.$store.dispatch('decrementProductsQuantity', product);
        }
      }
    },
    productPriceDetails(product) {
      const value = this.$options.filters.currency(product.valor * 100);
      const tax = product.valor_conveniencia
        ? ` + ${this.$options.filters.currency(
            product.valor_conveniencia * 100
          )} taxa`
        : '';
      const lote = ` (Lote ${product.lote})`;
      if (product.cupom === 1)
        return `<span style="font-size: 16px; color: #00A65A">${value}</span>${tax}${
          this.eventDetails &&
          this.eventDetails.exibir_lote &&
          product.tipo_produto !== 'M'
            ? lote
            : ''
        }`;
      else
        return `<span style="font-size: 16px; color: #1976d2">${value}</span>${tax}${
          this.eventDetails &&
          this.eventDetails.exibir_lote &&
          product.tipo_produto !== 'M'
            ? lote
            : ''
        }`;
    },
  },
  filters: {
    limit: value => {
      return value.substring(0, 14);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~@/assets/product/productTypes.styl"
</style>
